import { TFunction } from "i18next";

const getPrioritizedStatus = (
  quoteSellers: Array<{ state: string }>,
): string => {
  const statusPriority: Array<
    | "buy_on"
    | "bought_assisted"
    | "buy_off"
    | "lost"
    | "archived"
    | "follow"
    | "customer"
    | "customer_store"
    | "open_store"
    | "quoting"
    | "store"
    | "unknown"
  > = [
    "buy_on",
    "bought_assisted",
    "buy_off",
    "lost",
    "archived",
    "follow",
    "customer",
    "customer_store",
    "open_store",
    "quoting",
    "store",
    "unknown"
  ];

  for (const priority of statusPriority) {
    const matchedSeller = quoteSellers.find(
      (seller) => seller.state === priority,
    );
    if (matchedSeller) {
      // Return the real state (incl. bought_assisted) so list chips show the
      // distinct "Comprado asistido" label. Kanban/funnel collapse it into the
      // Comprado bucket on their own (see kanban/list.tsx + funnel-chart).
      return matchedSeller.state;
    }
  }
  return "unknown";
};


const getStatusMap = (t: TFunction) => ({
  buy_on: {
    label: t("quotes.status.Bought"),
    style: {
      backgroundColor: "rgba(246, 255, 237, 1)",
      borderColor: "rgba(183, 235, 143, 1)",
      color: "rgba(82, 196, 26, 1)",
    },
  },
  bought_assisted: {
    label: t("quotes.status.BoughtAssisted"),
    style: {
      backgroundColor: "rgba(246, 255, 237, 1)",
      borderColor: "rgba(135, 208, 104, 1)",
      color: "rgba(56, 158, 13, 1)",
    },
  },
  buy_off: {
    label: t("quotes.status.BoughtOff"),
    style: {
      backgroundColor: "rgba(233, 244, 239, 1)",
      borderColor: "rgba(70, 140, 105, 1)",
      color: "rgba(21, 116, 75, 1)",
    },
  },
  lost: {
    label: t("quotes.status.Lost"),
    style: {
      backgroundColor: "rgba(255, 241, 240, 1)",
      borderColor: "rgba(255, 163, 158, 1)",
      color: "rgba(245, 34, 45, 1)",
    },
  },
  archived: {
    label: t("quotes.status.Archived"),
    style: {
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "rgba(217, 217, 217, 1)",
      color: "rgba(0, 0, 0, 0.88)",
    },
  },
  follow: {
    label: t("quotes.status.Following"),
    style: {
      backgroundColor: "rgba(255, 247, 230, 1)",
      borderColor: "rgba(255, 213, 145, 1)",
      color: "rgba(250, 140, 22, 1)",
    },
  },
  customer: {
    label: t("quotes.status.Customer"),
    style: {
      backgroundColor: "rgba(249, 240, 255, 1)",
      borderColor: "rgba(211, 173, 247, 1)",
      color: "rgba(114, 46, 209, 1)",
    },
  },
   customer_store: {
    label: t("quotes.status.Customer"),
    style: {
      backgroundColor: "rgba(249, 240, 255, 1)",
      borderColor: "rgba(211, 173, 247, 1)",
      color: "rgba(114, 46, 209, 1)",
    },
  },
  open_store: {
    label: t("quotes.status.Customer"),
    style: {
      backgroundColor: "rgba(249, 240, 255, 1)",
      borderColor: "rgba(211, 173, 247, 1)",
      color: "rgba(114, 46, 209, 1)",
    },
  },
  quoting: {
    label: "Store",
    style: {
      backgroundColor: "rgba(230, 255, 251, 1)",
      borderColor: "rgba(135, 232, 222, 1)",
      color: "rgba(19, 194, 194, 1)",
    },
  },
  store: {
    label: "Store",
    style: {
      backgroundColor: "rgba(230, 255, 251, 1)",
      borderColor: "rgba(135, 232, 222, 1)",
      color: "rgba(19, 194, 194, 1)",
    },
  },
  unknown: {
    label: "Others",
    style: {
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "rgba(200, 200, 200, 1)",
      color: "rgba(0, 0, 0, 0.45)",
    },
  },
});

// Mapeo de estados y titulos/labels
const getStatuses = (t: TFunction) => [
  { id: "buy_on", label: t("quotes.status.Bought") },
  { id: "buy_off", label: t("quotes.status.BoughtOff") },
  { id: "lost", label: t("quotes.status.Lost") },
  { id: "archived", label: t("quotes.status.Archived") },
  { id: "follow", label: t("quotes.status.Following") },
  { id: "customer", label: t("quotes.status.Customer") },
  { id: "quoting", label: t("quotes.status.Quoting") },
];

export { getPrioritizedStatus, getStatusMap, getStatuses };
